import { PaymentInfo, PayPlanPayInformation } from '../styles';
import React from 'react';
import PropTypes from 'prop-types';

export const PayPlanMethodInfo = (props) => {
  const { account } = props;
  return (
    <>
      {account?.electronicPaymentSource[0]?.methodCd &&
        !account?.payPlan?.payPlanTypeCd?.includes('None') && (
          <PayPlanPayInformation>
            This pay plan uses{' '}
            <PaymentInfo>
              {account.electronicPaymentSource[0].methodCd} -{' '}
              {account.electronicPaymentSource[0].methodCd === 'ACH'
                ? account.electronicPaymentSource[0].achBankAccountNumber.slice(-4)
                : account.electronicPaymentSource[0].creditCardNumber}{' '}
            </PaymentInfo>
            as a payment method.{' '}
          </PayPlanPayInformation>
        )}
    </>
  );
};
PayPlanMethodInfo.propTypes = {
  account: PropTypes.object,
};